import type {
  ComorbidityAssessment,
  ComorbidityVerificationUpdate,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-564 — the doctor's BMI 27–30 assessment block. Both calls return the
// whole block: the PUT is an upsert of one condition's verification and the
// server re-derives everything, so the panel never shows a stale row.

export async function fetchComorbidityAssessment(
  patientId: string,
): Promise<ComorbidityAssessment> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${patientId}/comorbidity-verification`,
    { headers: commonHeaders(), ...withCredentials },
  );
  return jsonOr401(res);
}

export async function putComorbidityVerification(
  patientId: string,
  update: ComorbidityVerificationUpdate,
): Promise<ComorbidityAssessment> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${patientId}/comorbidity-verification`,
    {
      method: "PUT",
      headers: commonHeaders(),
      body: JSON.stringify(update),
      ...withCredentials,
    },
  );
  return jsonOr401(res);
}
